import Alpine from 'alpinejs';
const stickers = require('./stickers.json');
const colors = require('./colors.json');

window.addEventListener('load', () => {
	Alpine.data('chat', () => ({
		message: '',
		color: "#FFFFFF",
		cooldown: false,
		showStickers: true,
		showChat: true,
		showColorPicker: false,
		showColorPickerIcon: true,
		stickers: [],
		colors: [],
	    init () {
	    	this.colors = colors,
	        this.stickers = stickers.map((code) => {
	        	return {
	        		code,
	        		img: `./build/img/stickers/${code}.png`
	        	}
	        })
	    },
	    sendMessage () {
	    	if (this.cooldown) {
	    		return;
	    	}
	    	window.sendMessage(this.message, this.color);
	    	this.message = '';
	    	this.setCooldown()
	    	this.$refs.input.focus();
	    },
	    sendPresetMessage (id) {
	    	if (this.cooldown) {
	    		return;
	    	}
	    	var text = '';
	    	if (id === 'duce') {
	    		text = 'DUCE DUCE DUCE DUCE DUCE DUCE DUCE DUCE DUCE DUCE DUCE DUCE DUCE DUCE DUCE DUCE DUCE DUCE DUCE DUCE DUCE DUCE DUCE DUCE DUCE DUCE DUCE DUCE DUCE DUCE DUCE DUCE DUCE DUCE DUCE DUCE';
	    	}
	    	if (id === 'wani') {
	    		text = 'WANI WANI WANI WANI WANI WANI WANI WANI WANI WANI WANI WANI WANI WANI WANI WANI WANI WANI WANI WANI WANI WANI WANI WANI WANI WANI WANI WANI WANI WANI WANI WANI WANI WANI WANI WANI';
	    	}
	    	window.sendMessage(text, this.color);
	    	this.message = '';
	    	this.setCooldown(5)
	    	this.$refs.input.focus();
	    },
	    sendSticker (e) {
	    	if (this.cooldown) {
	    		return;
	    	}
	    	const code = e.target.getAttribute('data-sticker-id');
	    	window.sendSticker(`@sticker(${code})`);
	    	this.setCooldown()
	    	this.$refs.input.focus();
	    },
	    chooseColor (hex) {
	    	this.color = hex;
	    	this.showColorPicker = false;
	    	this.showColorPickerIcon = (hex === '#FFFFFF');
	    	this.$refs.input.focus();
	    },
	    toggleDanmaku () {
	    	this.showChat = window.toggleDanmaku();
	    },
	    toggleStickers () {
	    	this.showStickers = !this.showStickers;
	    },
	    toggleColorPicker () {
	    	this.showColorPicker = !this.showColorPicker;
	    },
	    setCooldown (seconds = 2) {
	    	this.cooldown = true;
	    	setTimeout(() => {
            	this.cooldown = false;
            }, seconds * 1000);
	    }
	}));

	Alpine.start();
});
